(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoitzi-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const home = document.querySelector('.yoitzi-home--motion');

    if (!home || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const revealItems = home.querySelectorAll(
      [
        '.yoitzi-section',
        '.yoitzi-apparel',
        '.yoitzi-found',
        '.yoitzi-newsletter',
        '.yoitzi-mood-card',
        '.yoitzi-guide-card',
        '.yoitzi-product-card',
        '.yoitzi-edit-card',
        '.yoitzi-trust-grid > div',
        '.yoitzi-story-card',
      ].join(',')
    );

    revealItems.forEach((item, index) => {
      item.classList.add('yoitzi-reveal');
      item.style.setProperty('--yoitzi-reveal-delay', `${Math.min(index % 4, 3) * 70}ms`);
    });

    home.classList.add('yoitzi-motion-ready');

    if (!('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.16,
      }
    );

    revealItems.forEach((item) => observer.observe(item));
  })();

  } catch(e) { console.error(e); }
})();
})();
